import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'oauth/heartbeat',
});

export async function tick(uuid) {
    return backendEndpoint.get(`?clientApplicationUuid=${uuid}`);
}
